module.exports = __webpack_public_path__ + "img/manage-edit-icon.495d6933.svg";